/**
 * Shared admin-orders column template so the header and rows stay aligned.
 * Mobile keeps the client identity; wider screens progressively add
 * partner, status, order type, script count, due date, and sent date.
 */
export const ADMIN_ORDERS_GRID_CLASS =
  "grid items-center gap-x-3 " +
  "grid-cols-[1rem_1rem_minmax(0,1fr)_5.5rem] " +
  "sm:grid-cols-[1rem_1rem_minmax(0,1fr)_minmax(7rem,0.8fr)_9rem_5.5rem] " +
  "md:grid-cols-[1rem_1rem_minmax(0,1.1fr)_minmax(7rem,0.8fr)_4.5rem_3.5rem_9rem_9rem_5.5rem] " +
  "lg:grid-cols-[1rem_1rem_minmax(0,1.1fr)_minmax(7rem,0.8fr)_4.5rem_3.5rem_9rem_8.5rem_9rem_5.5rem]";

export const ADMIN_ORDERS_ROW_PADDING_CLASS = "px-3";

export const ADMIN_ORDERS_CELL_PARTNER_CLASS = "hidden sm:flex";
export const ADMIN_ORDERS_CELL_TYPE_CLASS = "hidden md:block";
export const ADMIN_ORDERS_CELL_SCRIPTS_CLASS = "hidden md:block";
export const ADMIN_ORDERS_CELL_STATUS_CLASS = "hidden sm:block";
export const ADMIN_ORDERS_CELL_SENT_CLASS = "hidden lg:block";
export const ADMIN_ORDERS_CELL_DUE_CLASS = "hidden md:block";
export const ADMIN_ORDERS_CELL_ACTIONS_CLASS = "flex items-center justify-end";
